<template>
  <div>
    <section>
      <div class="inner row5">
        <div class="title ">
          <h1
            class="boardTitle"
            v-if="
              getUser.roleName == $role.CORP || getUser.roleName == $role.USER
            "
          >
            1:1 문의
          </h1>
          <h1 class="boardTitle" v-else>1:1 문의 관리</h1>
        </div>
        <section>
          <div class="row4">
            <div class="bdTop">
              <div class="mainContext">
                <p>{{ saveData.title }}</p>
                <div class="flex mobileFlex">
                  <div class="flex mobileFlexAlignS">
                    <div class="qnaSubscript">
                      <span class="firstCon">작성자</span>
                      <span class="secondCon">
                        {{ saveData.name }}
                      </span>
                    </div>
                    <div class="qnaSubscript">
                      <span class="firstCon">등록일</span>
                      <span class="secondCon">
                        {{ saveData.regDate }}
                      </span>
                    </div>
                  </div>
                  <div class="flex flexAlignC mobileFlexAlign mobileTxtSize">
                    <p
                      v-for="(file, index) in saveData.fileList"
                      :key="index"
                      class="attechFileForm"
                    >
                      <span>첨부파일</span>

                      <span
                        class="attechFileImg qnaAttech"
                        @click="fileDownload(file.IDX, file.REAL_FILE_NAME)"
                      >
                        <strong> </strong>
                        {{ file.REAL_FILE_NAME }}
                        <span
                          v-if="
                            index != Object.keys(saveData.fileList).length - 1
                          "
                          >,
                        </span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="questionBox">
                <div class="questionTxtBox" v-html="saveData.content"></div>
              </div>
              <div
                v-if="
                  getUser.roleName == $role.CORP ||
                    getUser.roleName == $role.USER
                "
              >
                <div class="flex mobileFlex">
                  <div class="flex mobileFlexAlignS">
                    <div class="qnaSubscript">
                      <span class="firstCon">답변</span>
                    </div>
                  </div>
                  <div class="flex flexAlignC mobileFlexAlign mobileTxtSize">
                    <p
                      v-for="(file, index) in saveData.ansFileList"
                      :key="index"
                    >
                      <span>첨부파일</span>

                      <span
                        class="attechFileImg qnaAttech"
                        @click="fileDownload(file.IDX, file.REAL_FILE_NAME)"
                      >
                        <strong> </strong>
                        {{ file.REAL_FILE_NAME }}
                        <span
                          v-if="
                            index !=
                              Object.keys(saveData.ansFileList).length - 1
                          "
                          >,
                        </span>
                      </span>
                    </p>
                  </div>
                </div>
                <div class="answerBox">
                  <div class="answerTxtBox" v-html="saveData.answer"></div>
                </div>
              </div>
              <div v-else>
                <div class="answerTitle flex flexAlignS">
                  <p>
                    답변
                  </p>
                  <div class="detailInputBox flex flexAlignC">
                    <label>첨부파일</label>
                    <div class="detailFileInputBox">
                      <SingleFileUpload
                        v-bind:saveData="saveData"
                        @set-file="setFile"
                      ></SingleFileUpload>
                    </div>
                  </div>
                </div>
                <div class="answerBox">
                  <textarea
                    class="answerBoxItem"
                    placeholder="답변을 입력해주세요."
                    v-model="saveData.postAnswer"
                  ></textarea>
                </div>
              </div>

              <div
                class="subBtnContain flex flexAlignS"
                v-if="
                  getUser.roleName == $role.CORP ||
                    getUser.roleName == $role.USER
                "
              >
                <a href="#" @click="listViewBtn()">목록</a>
                <div class="prevNextBtnContain">
                  <a href="#" @click="goPrev" v-if="prevQna">이전글</a>
                  <a href="#" @click="goNext" v-if="nextQna">다음글</a>
                </div>
              </div>
              <div
                class="btnBox smTopPd"
                v-if="getUser.roleName == $role.ADMIN"
              >
                <button @click="listViewBtn()" class="redborderBtn">
                  취 소
                </button>
                <button class="redBtn" @click="answerSubmit">수 정</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/axios/axios";
import SingleFileUpload from "@/components/layout/board/SingleFileUpload";
import * as FileUtil from "@/utils/FileUtil";

export default {
  name: "QNADetail",
  components: {
    SingleFileUpload,
  },
  computed: {
    ...mapGetters("auth", ["getUser"]),
  },
  data() {
    return {
      saveData: {
        idx: "",
        title: "",
        content: "",
        regDate: "",
        file: null,
        fileGroupId: "",
        fileName: "",
        ansIdx: "",
        answer: "",
        postAnswer: "",
        name: "",
        fileList: null,
        ansFileList: null,
      },
      prevQna: {},
      nextQna: {},
      searchText: "",
    };
  },
  watch: {
    "$route.params.idx": {
      handler() {
        this.detailQna();
      },
    },
  },
  mounted() {
    this.detailQna();
  },
  methods: {
    listViewBtn() {
      this.$router.push({
        path: "/QnA",
        query: { searchText: this.searchText },
      });
    },
    goPrev() {
      let idx = this.prevQna.IDX;
      this.$router.push({ name: "qNADetail", params: { idx: idx } });
    },
    goNext() {
      let idx = this.nextQna.IDX;
      this.$router.push({ name: "qNADetail", params: { idx: idx } });
    },
    detailQna() {
      this.searchText = this.$route.params.searchText;
      let param = {
        IDX: this.$route.params.idx,
        SEARCH_TEXT: this.searchText,
      };

      axios
        .post("/api/qna/getQnaInfo", param)
        .then((response) => {
          if (response.status == 200) {
            let qna = response.data.QNA;
            this.saveData.idx = qna.IDX;
            this.saveData.title = qna.TITLE;
            this.saveData.content = qna.CONTENT.replace(
              /(?:\r\n|\r|\n)/g,
              "<br />",
            );
            this.saveData.regDate = qna.REGDATE;
            this.saveData.name = qna.NAME;
            this.saveData.fileList = qna.FILE_LIST;
            this.saveData.ansFileList = qna.ANS_FILELIST;
            this.saveData.ansIdx = qna.ANS_IDX;
            this.saveData.postAnswer = qna.ANSWER;
            this.saveData.answer = qna.ANSWER.replace(
              /(?:\r\n|\r|\n)/g,
              "<br />",
            );
            this.saveData.fileName = qna.ANS_FILE_NAME;
            this.saveData.fileGroupId = qna.ANSWER_FILE_GROUP_ID;

            this.prevQna = response.data.PREV_QNA;
            this.nextQna = response.data.NEXT_QNA;
          }
        })
        .catch(() => {});
    },
    answerSubmit() {
      let idx = this.saveData.idx;
      let ansIdx = this.saveData.ansIdx;
      let postAnswer = this.saveData.postAnswer;
      let file = this.saveData.file;

      if (!postAnswer) {
        this.$alert("알림", "답변을 입력해주세요.");
        return false;
      }

      const formData = new FormData();
      formData.append("idx", idx);
      if (ansIdx) {
        formData.append("ansIdx", ansIdx);
      }
      formData.append("answer", postAnswer);
      formData.append("uploadFile", file);

      axios
        .post("/api/admin/qna/submit", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((result) => {
          if (result.status == 200) {
            this.$alert("알림", "1:1 문의 답변이 등록되었습니다.", "", {
              closed: () => {
                this.listViewBtn();
              },
            });
          } else {
            this.$alert(
              "알림",
              "1:1 문의 답변 등록에 실패하였습니다. 관리자에게 문의해주세요.",
            );
          }
        })
        .catch((error) => {
          this.$alert(
            "알림",
            "1:1 문의 답변 등록에 실패하였습니다. 관리자에게 문의해주세요.<br>" +
              error.response.data.error,
          );
        });
    },
    fileDownload(idx, fileName) {
      FileUtil.FileDownload("/api/file/fileDownload", idx, fileName);
    },
    setFile(file) {
      this.saveData.file = file;
    },
  },
};
</script>

<style scoped lang="scss">
.sampleTemplate ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
}
</style>

<style scoped>
.mainContext {
  margin: 0 0 30px 0;
}
.bdTop {
  border-top: 2px solid #949494;
  padding: 30px 0 0;
}
.mainContext > p {
  margin: 0 0 18px 0;
}
.qnaSubscript {
  margin: 0 50px 0 0;
}
.qnaSubscript span {
  font-size: 24px;
  line-height: 35px;
}
.qnaSubscript span:first-child {
  margin: 0 10px 0 0;
}
.firstCon {
  color: #272727;
}
.secondCon {
  color: #777777;
}
.secondCon i {
  vertical-align: middle;
}
.questionBox {
  border: 1px solid #e7e7e7;
  padding: 20px 30px;
  min-height: 260px;
  font-size: 2rem;
}
.questionTxtBox {
  overflow: auto;
}
.answerTitle {
  padding: 10px 30px;
}
.answerBox {
  border: 1px solid #e7e7e7;
  padding: 20px 30px;
  min-height: 260px;
}
.answerTxtBox {
  overflow: auto;
}
.subBtnContain {
  padding: 10px 20px 0 30px;
}
.subBtnContain a {
  font-size: 24px;
  line-height: 35px;
  color: #272727;
}
.prevNextBtnContain a {
  margin: 0 0 0 40px;
}
.answerBoxItem {
  width: 100%;
  min-height: 220px;
  resize: none;
  border: 0;
  background: transparent;
  font-size: 24px;
  line-height: 35px;
  color: #272727;
  resize: none;
  font-family: "NotoSans";
}
.answerBoxItem:focus {
  outline: none;
}
@media screen and (max-width: 560px) {
  .bdTop {
    border: 0;
  }
  .qnaSubscript {
    margin: 0;
  }
  .qnaSubscript span {
    font-size: 14px;
    line-height: 20px;
  }
  .attechFileImg {
    width: 100%;
    padding: 0 0 0 33px;
    height: 22px;
    overflow: hidden;
  }
  .attechFileImg.qnaAttech::after {
    right: auto;
    left: 0;
    margin: 0 0 0 10px;
  }
  .questionBox {
    padding: 10px;
  }
  .questionTxtBox {
    font-size: 20px;
    line-height: 29px;
  }
  .answerBox {
    padding: 10px;
  }
  .answerTxtBox {
    font-size: 20px;
    line-height: 29px;
  }
  .subBtnContain {
    padding: 10px 0 0 0;
  }
  .mainContext {
    margin: 0 0 20px;
  }
  .answerTitle {
    padding: 10px 0;
  }
}
</style>
